import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8be4ffde"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "segment-component" }
const _hoisted_2 = { class: "col-12 md:col-4 mt-0" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "flex font-normal mb-1"
}, "属性で絞り込み", -1))
const _hoisted_4 = { class: "px-2 form-segment border-round-top flex justify-content-between align-items-center" }
const _hoisted_5 = { class: "content ml-5" }
const _hoisted_6 = { class: "col-12 md:col-4 mt-0 px-0 mb-5" }
const _hoisted_7 = { class: "form-checkbox mb-5" }
const _hoisted_8 = ["for"]
const _hoisted_9 = { class: "dialog-footer grid mb-3" }
const _hoisted_10 = { class: "col-6 flex justify-content-center" }
const _hoisted_11 = { class: "col-6 flex justify-content-center" }

import { reactive, ref, withDefaults } from "vue";
import { ICampaignSegments, ICampaignSegmentCategories } from "@/clinic/typings/entities/campaign";
import { get, set, useArrayFind } from "@vueuse/core";
import { useStore } from "vuex";
import { CampaignServices } from "@/clinic/services";
import { ApiCampaignSegmentCategoriesReq, ApiCampaignSegmentCategoriesRes } from "@/clinic/typings";

type ICampaignSegment = {
  segments: ICampaignSegments[];
  index: number;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'segment',
  props: {
    segments: null,
    index: null
  },
  emits: ["updateDate"],
  setup(__props: any, { emit: emits }) {

const props = __props as { segments: ICampaignSegments[], index: number };

const visible = ref<boolean>(false);
const formSegment = reactive({
  segmentsSelected: {} as ICampaignSegments,
  segmentCategory: [] as ICampaignSegmentCategories[],
  segmentsID: 0,
});

const valueSegment = ref();
const valueSegmentCategories = ref("未設定");



const getCheckBoxValue = () => {
  const segmentCategory = get(formSegment.segmentCategory);
  return segmentCategory.reduce((prevVal, currVal, idx) => {
    return idx === 0 ? currVal.name : prevVal + ", " + currVal.name;
  }, "");
};

const store = useStore();
const segmentCategories = ref<ICampaignSegmentCategories[] | null>(null);
const loadSegmentCategories = async (id: number | undefined) => {
  if (!id) return;
  const channelId = await store.dispatch("authClient/getChannelIdCookie");
  const params: ApiCampaignSegmentCategoriesReq = {
    channel_id: get(channelId),
    category_id: id,
  };
  const { data } = await CampaignServices.getCampaignSegmentCategories(params);
  const { segments: segmentCategoriesData } = get(data) as unknown as ApiCampaignSegmentCategoriesRes;
  set(segmentCategories, get(segmentCategoriesData) as unknown as ICampaignSegmentCategories[]);
};

const onSubmit = async () => {
  if (get(formSegment.segmentCategory.length > 0)) {
    set(valueSegment, formSegment.segmentsSelected?.name);
  } else {
    set(valueSegment, null);
  }
  set(valueSegmentCategories, getCheckBoxValue());
  const res = formSegment.segmentCategory.map(({ category_id, name: value, ...data }) => {
    return { category_id, value };
  });
  emits("updateDate", res, props.index);
  set(visible, false);
};
const resetSegment = () => set(formSegment, "segmentCategory", []);
const onChangingSegmentCategories = async (segmentsID: number): Promise<boolean> => {
  set(
    formSegment,
    "segmentsSelected",
    get(useArrayFind(props?.segments, (val: { id: number }) => val.id == segmentsID)) as ICampaignSegments
  );
  await loadSegmentCategories(segmentsID);
  resetSegment();
  return true;
};

return (_ctx: any,_cache: any) => {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", null, _toDisplayString(valueSegment.value), 1),
        _createElementVNode("span", {
          class: "icon icon-pencil-orange-svg text-right cursor-pointer",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (visible.value = true))
        })
      ]),
      _createVNode(_component_InputText, {
        class: "border-top-none border-noround-top",
        readonly: "",
        value: valueSegmentCategories.value
      }, null, 8, ["value"]),
      _createVNode(_component_Dialog, {
        visible: visible.value,
        "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((visible).value = $event)),
        modal: "",
        header: "フィルター設定",
        draggable: false,
        style: { width: '800px' }
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_Dropdown, {
                modelValue: formSegment.segmentsID,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formSegment.segmentsID) = $event)),
                options: props.segments,
                optionLabel: "name",
                optionValue: "id",
                class: "font-normal shadow-none w-20rem",
                onChange: _cache[2] || (_cache[2] = 
                async ({ value: segmentsID }: DropdownChangeEvent) => await onChangingSegmentCategories(segmentsID)
              ),
                placeholder: "-- 選ぶ --"
              }, null, 8, ["modelValue", "options"])
            ]),
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(segmentCategories.value, (segmentCategory) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: segmentCategory.id,
                  class: "flex align-items-center mt-3 ml-1"
                }, [
                  _createVNode(_component_Checkbox, {
                    modelValue: formSegment.segmentCategory,
                    "onUpdate:modelValue": ($event: any) => ((formSegment.segmentCategory) = $event),
                    inputId: segmentCategory.id,
                    name: "generation",
                    class: "mr-2 shadow-none hover-border",
                    value: segmentCategory
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "inputId", "value"]),
                  _createElementVNode("label", {
                    for: segmentCategory.id
                  }, _toDisplayString(segmentCategory.name), 9, _hoisted_8)
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_Button, {
                label: "閉じる",
                class: "p-button-light",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (visible.value = false))
              })
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_Button, {
                label: "設定する",
                onClick: onSubmit
              })
            ])
          ])
        ]),
        _: 1
      }, 8, ["visible"])
    ])
  ]))
}
}

})